angular
	.module('empower.contactUs')
	.constant('feedbackEnquiryConst', {
		VIC_EMPLOYER: [
			{ id : 0 , name : 'Premium Enquiry' },
			{ id : 1 , name : 'Claim Enquiry' },
			{ id : 2 , name : 'Compliment and feedback' },
			{ id : 6 , name : 'Complaint' },
			{ id : 3 , name : 'Update my contact number or address' },
			{ id : 4 , name : 'Member Benefits' },
			{ id : 5 , name : 'Other' }
		],
		NSW_EMPLOYER: [
			{ id : 1 , name : 'Claim Enquiry' },
			{ id : 2 , name : 'Compliment and feedback' },
			{ id : 6 , name : 'Complaint' },
			{ id : 4 , name : 'Member Benefits' },
			{ id : 5 , name : 'Other' }
		],
		NSI_WORKER: [
			{ id : 1 , name : 'Claim Enquiry' },
			{ id : 2 , name : 'Compliment and feedback' },
			{ id : 6 , name : 'Complaint' },
			{ id : 3 , name : 'Update my contact number or address' },
			{ id : 5 , name : 'Other' }
		],
		WORKER: [
			{ id : 1 , name : 'Claim Enquiry' },
			{ id : 2 , name : 'Compliment and feedback' },
			{ id : 6 , name : 'Complaint' },
			{ id : 3 , name : 'Update my contact number or address' },
			{ id : 5 , name : 'Other' }
		]
	});